'use strict';

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var base = require('./base.js');

var errors = require('./errors.js');

var debug = require('debug');

var pushable = require('it-pushable');

var drain = require('it-drain');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var pushable__default = /*#__PURE__*/_interopDefaultLegacy(pushable);

var drain__default = /*#__PURE__*/_interopDefaultLegacy(drain);

var log = debug__default['default']('datastore:core:tiered');

var TieredDatastore = /*#__PURE__*/function (_base$BaseDatastore) {
  _inherits(TieredDatastore, _base$BaseDatastore);

  var _super = _createSuper(TieredDatastore);

  function TieredDatastore(stores) {
    var _this3;

    _classCallCheck(this, TieredDatastore);

    _this3 = _super.call(this);
    _this3.stores = stores.slice();
    return _this3;
  }

  _createClass(TieredDatastore, [{
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return Promise.all(this.stores.map(function (store) {
                  return store.open();
                }));

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                throw errors.dbOpenFailedError();

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 5]]);
      }));

      function open() {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key, value) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return Promise.all(this.stores.map(function (store) {
                  return store.put(key, value);
                }));

              case 3:
                _context2.next = 8;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](0);
                throw errors.dbWriteFailedError();

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 5]]);
      }));

      function put(_x, _x2) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key, options) {
        var _iterator3, _step3, store, res;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _iterator3 = _createForOfIteratorHelper(this.stores);
                _context3.prev = 1;

                _iterator3.s();

              case 3:
                if ((_step3 = _iterator3.n()).done) {
                  _context3.next = 18;
                  break;
                }

                store = _step3.value;
                _context3.prev = 5;
                _context3.next = 8;
                return store.get(key, options);

              case 8:
                res = _context3.sent;

                if (!res) {
                  _context3.next = 11;
                  break;
                }

                return _context3.abrupt("return", res);

              case 11:
                _context3.next = 16;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](5);
                log(_context3.t0);

              case 16:
                _context3.next = 3;
                break;

              case 18:
                _context3.next = 23;
                break;

              case 20:
                _context3.prev = 20;
                _context3.t1 = _context3["catch"](1);

                _iterator3.e(_context3.t1);

              case 23:
                _context3.prev = 23;

                _iterator3.f();

                return _context3.finish(23);

              case 26:
                throw errors.notFoundError();

              case 27:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 20, 23, 26], [5, 13]]);
      }));

      function get(_x3, _x4) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "has",
    value: function () {
      var _has = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(key, options) {
        var _iterator4, _step4, s;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _iterator4 = _createForOfIteratorHelper(this.stores);
                _context4.prev = 1;

                _iterator4.s();

              case 3:
                if ((_step4 = _iterator4.n()).done) {
                  _context4.next = 11;
                  break;
                }

                s = _step4.value;
                _context4.next = 7;
                return s.has(key, options);

              case 7:
                if (!_context4.sent) {
                  _context4.next = 9;
                  break;
                }

                return _context4.abrupt("return", true);

              case 9:
                _context4.next = 3;
                break;

              case 11:
                _context4.next = 16;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4["catch"](1);

                _iterator4.e(_context4.t0);

              case 16:
                _context4.prev = 16;

                _iterator4.f();

                return _context4.finish(16);

              case 19:
                return _context4.abrupt("return", false);

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 13, 16, 19]]);
      }));

      function has(_x5, _x6) {
        return _has.apply(this, arguments);
      }

      return has;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(key, options) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return Promise.all(this.stores.map(function (store) {
                  return store.delete(key, options);
                }));

              case 3:
                _context5.next = 8;
                break;

              case 5:
                _context5.prev = 5;
                _context5.t0 = _context5["catch"](0);
                throw errors.dbDeleteFailedError();

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 5]]);
      }));

      function _delete(_x7, _x8) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "putMany",
    value: function putMany(source) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var error, pushables, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;

        return _regeneratorRuntime.wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                pushables = _this.stores.map(function (store) {
                  var source = pushable__default['default']();
                  drain__default['default'](store.putMany(source, options)).catch(function (err) {
                    error = err;
                  });
                  return source;
                });
                _context7.prev = 1;
                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context7.prev = 4;
                _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                  var pair;
                  return _regeneratorRuntime.wrap(function _loop$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          pair = _step.value;

                          if (!error) {
                            _context6.next = 3;
                            break;
                          }

                          throw error;

                        case 3:
                          pushables.forEach(function (p) {
                            return p.push(pair);
                          });
                          _context6.next = 6;
                          return pair;

                        case 6:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _loop);
                });
                _iterator = _asyncIterator(source);

              case 7:
                _context7.next = 9;
                return _awaitAsyncGenerator(_iterator.next());

              case 9:
                if (!(_iteratorAbruptCompletion = !(_step = _context7.sent).done)) {
                  _context7.next = 14;
                  break;
                }

                return _context7.delegateYield(_loop(), "t0", 11);

              case 11:
                _iteratorAbruptCompletion = false;
                _context7.next = 7;
                break;

              case 14:
                _context7.next = 20;
                break;

              case 16:
                _context7.prev = 16;
                _context7.t1 = _context7["catch"](4);
                _didIteratorError = true;
                _iteratorError = _context7.t1;

              case 20:
                _context7.prev = 20;
                _context7.prev = 21;

                if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                  _context7.next = 25;
                  break;
                }

                _context7.next = 25;
                return _awaitAsyncGenerator(_iterator.return());

              case 25:
                _context7.prev = 25;

                if (!_didIteratorError) {
                  _context7.next = 28;
                  break;
                }

                throw _iteratorError;

              case 28:
                return _context7.finish(25);

              case 29:
                return _context7.finish(20);

              case 30:
                _context7.prev = 30;
                pushables.forEach(function (p) {
                  return p.end();
                });
                return _context7.finish(30);

              case 33:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee6, null, [[1,, 30, 33], [4, 16, 20, 30], [21,, 25, 29]]);
      }))();
    }
  }, {
    key: "deleteMany",
    value: function deleteMany(source) {
      var _this2 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var error, pushables, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _loop2, _iterator2, _step2;

        return _regeneratorRuntime.wrap(function _callee7$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                pushables = _this2.stores.map(function (store) {
                  var source = pushable__default['default']();
                  drain__default['default'](store.deleteMany(source, options)).catch(function (err) {
                    error = err;
                  });
                  return source;
                });
                _context9.prev = 1;
                _iteratorAbruptCompletion2 = false;
                _didIteratorError2 = false;
                _context9.prev = 4;
                _loop2 = /*#__PURE__*/_regeneratorRuntime.mark(function _loop2() {
                  var key;
                  return _regeneratorRuntime.wrap(function _loop2$(_context8) {
                    while (1) {
                      switch (_context8.prev = _context8.next) {
                        case 0:
                          key = _step2.value;

                          if (!error) {
                            _context8.next = 3;
                            break;
                          }

                          throw error;

                        case 3:
                          pushables.forEach(function (p) {
                            return p.push(key);
                          });
                          _context8.next = 6;
                          return key;

                        case 6:
                        case "end":
                          return _context8.stop();
                      }
                    }
                  }, _loop2);
                });
                _iterator2 = _asyncIterator(source);

              case 7:
                _context9.next = 9;
                return _awaitAsyncGenerator(_iterator2.next());

              case 9:
                if (!(_iteratorAbruptCompletion2 = !(_step2 = _context9.sent).done)) {
                  _context9.next = 14;
                  break;
                }

                return _context9.delegateYield(_loop2(), "t0", 11);

              case 11:
                _iteratorAbruptCompletion2 = false;
                _context9.next = 7;
                break;

              case 14:
                _context9.next = 20;
                break;

              case 16:
                _context9.prev = 16;
                _context9.t1 = _context9["catch"](4);
                _didIteratorError2 = true;
                _iteratorError2 = _context9.t1;

              case 20:
                _context9.prev = 20;
                _context9.prev = 21;

                if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                  _context9.next = 25;
                  break;
                }

                _context9.next = 25;
                return _awaitAsyncGenerator(_iterator2.return());

              case 25:
                _context9.prev = 25;

                if (!_didIteratorError2) {
                  _context9.next = 28;
                  break;
                }

                throw _iteratorError2;

              case 28:
                return _context9.finish(25);

              case 29:
                return _context9.finish(20);

              case 30:
                _context9.prev = 30;
                pushables.forEach(function (p) {
                  return p.end();
                });
                return _context9.finish(30);

              case 33:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee7, null, [[1,, 30, 33], [4, 16, 20, 30], [21,, 25, 29]]);
      }))();
    }
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return Promise.all(this.stores.map(function (store) {
                  return store.close();
                }));

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee8, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "batch",
    value: function batch() {
      var batches = this.stores.map(function (store) {
        return store.batch();
      });
      return {
        put: function put(key, value) {
          batches.forEach(function (b) {
            return b.put(key, value);
          });
        },
        delete: function _delete(key) {
          batches.forEach(function (b) {
            return b.delete(key);
          });
        },
        commit: function () {
          var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(options) {
            var _iterator5, _step5, batch;

            return _regeneratorRuntime.wrap(function _callee9$(_context11) {
              while (1) {
                switch (_context11.prev = _context11.next) {
                  case 0:
                    _iterator5 = _createForOfIteratorHelper(batches);
                    _context11.prev = 1;

                    _iterator5.s();

                  case 3:
                    if ((_step5 = _iterator5.n()).done) {
                      _context11.next = 9;
                      break;
                    }

                    batch = _step5.value;
                    _context11.next = 7;
                    return batch.commit(options);

                  case 7:
                    _context11.next = 3;
                    break;

                  case 9:
                    _context11.next = 14;
                    break;

                  case 11:
                    _context11.prev = 11;
                    _context11.t0 = _context11["catch"](1);

                    _iterator5.e(_context11.t0);

                  case 14:
                    _context11.prev = 14;

                    _iterator5.f();

                    return _context11.finish(14);

                  case 17:
                  case "end":
                    return _context11.stop();
                }
              }
            }, _callee9, null, [[1, 11, 14, 17]]);
          }));

          function commit(_x9) {
            return _commit.apply(this, arguments);
          }

          return commit;
        }()
      };
    }
  }, {
    key: "query",
    value: function query(q, options) {
      return this.stores[this.stores.length - 1].query(q, options);
    }
  }, {
    key: "queryKeys",
    value: function queryKeys(q, options) {
      return this.stores[this.stores.length - 1].queryKeys(q, options);
    }
  }]);

  return TieredDatastore;
}(base.BaseDatastore);

exports.TieredDatastore = TieredDatastore;